import { ReactElement, useEffect, Suspense } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { useRecoilValue } from 'recoil'
import { ACLContainer } from '../../components/acl-container/acl-container'
import { currenciesState } from '../../states/currencies-state'
import CurrencyForm from '../../forms/currency-form'
import { CurrencyItem } from '../../components/currencies-list/currency-item'

const CurrenciesScreen = (): ReactElement => {
  const currencies = useRecoilValue(currenciesState)

  return (
    <Flexbox flex={1} isCol>
      <ScreenTitle title={'Currencies'} />
      <table className="table table-compact w-full">
        <thead>
          <tr>
            <th>Name</th>
            <th>Code</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {currencies.map((item) => (
            <CurrencyItem showId={false} id={item.id} name={item.name} code={item.code} />
          ))}
        </tbody>
      </table>
      {currencies?.length === 0 && <Flexbox className="p-4">No currencies yet.</Flexbox>}
      <ACLContainer onlyAdmin>
        <Suspense>
          <h2 className="text-2xl font-bold uppercase pb-4 pt-8">Add Currency</h2>
          <CurrencyForm />
        </Suspense>
      </ACLContainer>
    </Flexbox>
  )
}

export default CurrenciesScreen